import { distance } from '../maths';
export default class GraphElement {
    distance(P) {
        const H = this.orthoProjection(P);
        return distance(H, P);
    }
}
//# sourceMappingURL=GraphElement.js.map